import { render } from "./EmailSentTableModal.vue?vue&type=template&id=1279b565&scoped=true"
import script from "./EmailSentTableModal.vue?vue&type=script&lang=js"
export * from "./EmailSentTableModal.vue?vue&type=script&lang=js"

import "./EmailSentTableModal.vue?vue&type=style&index=0&id=1279b565&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1279b565"]])

export default __exports__